import { EnumFiscalResidence } from '@blank/api'
import { EnumUserLocale } from 'modules/common/types/locale'

export enum EnumHomeCountryCode {
  FRA = 'FRA',
  ITA = 'ITA',
}

export interface CountryConfig {
  canAddCompanyDataManually: boolean
  companyIdentificationNumberLength: number
  shouldChooseDomiciliationOnSignup: boolean
  isBeta: boolean
  canAddEnterpriseMandate: boolean
  shouldDisplayUserFeedbackButton: boolean
  isSponsorshipEnabled: boolean
  increaseTransferLimitTypeformId: string
  feedbackTypeformId: string
  accountClosingTypeformId: string
  shouldDisplayAdditionalTouOnSelectOffer: boolean
  fiscalResidenceOptions: EnumFiscalResidence[]
  homeCountryCode: EnumHomeCountryCode
  invoicing: {
    canCreateEstimateDocument: boolean
    canAddFiscalTaxesToDocument: boolean
    canAddFiscalStampToDocument: boolean
    shouldSelectVATExonerationCode: boolean
  }
  shouldDisplayAverageBalanceDocuments: boolean
  shouldBuildMicroEnterpriseCreationURLWithParams: boolean
  whatsAppSupportNumber: string | undefined
  shouldCustomizeCardFraudInsuranceRedirectionUrl: boolean
  fileComplaintTypeformId: string
  shouldDisplayZendeskMessagingWidget: boolean
  zendeskScriptKey: string
  hasOptionalConsents: boolean
}

export interface ConfigType {
  internalBankName: string
  locales: EnumUserLocale[]
  hasSubBanks: boolean
  signupConfig: {
    shouldDisplayCommercialSolicitationOptIn: boolean
    shouldDisplayOperatedBy: boolean
    canAccessManagementOffer: boolean
    canAccessQuickSignup: boolean
  }
  defaultPublicOfferCount: number
  caravelAffiliationCode: string
}

export type LocalizedCountryConfig = Partial<
  Record<EnumUserLocale, CountryConfig>
> & {
  [EnumUserLocale.FR]: CountryConfig
}
